import React from 'react';
import PropTypes from 'prop-types';
import ReactionDetailRowComponent from '@Components/Results/reactions/reaction-details/reaction-detail-row.component';

export default class SynthesisPlannerConditionsChunkComponent extends React.PureComponent {
  render() {
    const {
      chunk,
      metadata,
      details,
      index,
      onFullTextLinkClick,
      onIssueCitedCounterClick,
      onExperimentalProcedureOpen,
      onAbstractOpen,
      onAuthorClick,
      renderCheckboxesColumn,
      isChecked,
      isVisible,
      setChecked,
    } = this.props;

    return (
      <ReactionDetailRowComponent
        metadata={metadata}
        key={`${details.reactionId}-${index}`}
        detail={chunk}
        index={`${index}`}
        reactionId={details.reactionId}
        databaseId={metadata.databaseId}
        onFullTextLinkClick={onFullTextLinkClick}
        onIssueCitedCounterClick={onIssueCitedCounterClick}
        onExperimentalProcedureOpen={onExperimentalProcedureOpen}
        onAbstractOpen={onAbstractOpen}
        onAuthorClick={onAuthorClick}
        renderCheckboxesColumn={renderCheckboxesColumn}
        isChecked={isChecked}
        isVisible={isVisible}
        setChecked={setChecked}
      />
    );
  }
}

SynthesisPlannerConditionsChunkComponent.defaultProps = {
  onExperimentalProcedureOpen: () => null,
  onFullTextLinkClick: () => null,
  onIssueCitedCounterClick: () => null,
  onAbstractOpen: () => null,
  onAuthorClick: () => null,
  setChecked: () => null,
};

SynthesisPlannerConditionsChunkComponent.propTypes = {
  chunk: PropTypes.object.isRequired,
  metadata: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onExperimentalProcedureOpen: PropTypes.func,
  onFullTextLinkClick: PropTypes.func,
  details: PropTypes.object,
  onIssueCitedCounterClick: PropTypes.func,
  onAbstractOpen: PropTypes.func,
  onAuthorClick: PropTypes.func,
  renderCheckboxesColumn: PropTypes.bool,
  isChecked: PropTypes.bool,
  isVisible: PropTypes.bool,
  setChecked: PropTypes.func,
};
